const networkIdentifiers = [
  'blog',
  'instagram',
  'youtube',
  'twitter',
  'facebook',
  'twitch',
  'snapchat',
  'pinterest',
  'tiktok',
] as const;

export type TNetworkIdentifier = typeof networkIdentifiers[number];

export function isNetworkIdentifier(value: string): value is TNetworkIdentifier {
  return (networkIdentifiers as readonly string[]).includes(value);
}

export type TNetworkIconType =
  | TNetworkIdentifier
  | 'additional_images'
  | 'additional_videos'
  | 'other';
